import Vue from 'vue'
import {
  SEARCH_BOOLEAN_ATTRIBUTE,
  SEARCH_INTEGER_ATTRIBUTE,
  SEARCH_LIST_ATTRIBUTE, SEARCH_MINMAX_ATTRIBUTE,
  SEARCH_STRING_ATTRIBUTE
} from '~/utils/search/search-attribute.class'

export class SearchFilter {
  _filters = null

  constructor (ctx) {
    this._filters = Vue.observable({})
  }

  get filters () {
    return this._filters
  }

  set filters (args) {
    this._filters = args
  }

  getFilterSetterMethodName (key) {
    const methodName = `set${key
      .split('_')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join('')}Filter`

    if (typeof this[methodName] === 'function') {
      return methodName
    } else {
      return 'defaultFilterSetter'
    }
  }

  defaultFilterSetter (key, value) {
    const attributeType = this.getAttributeType(key)

    if (!attributeType) {
      console.error(`Filter with key: ${key} not found`)
      return
    }

    const dataKey = attributeType.dataKey || attributeType.key

    if (attributeType.type === SEARCH_MINMAX_ATTRIBUTE) {
      if (Array.isArray(value) && value.length > 0) {
        const firstAttributeKey = value[0]?.key
        const lastAttributeKey = value[value.length - 1]?.key
        const oldValue = this.getAttributeValue(dataKey) || { min: 0, max: 0 }
        const newValue = { ...oldValue }
        const attributeChanged = this.isChangedAttribute(dataKey)
        let newValueCorrected = false

        if (!newValue.min && firstAttributeKey !== undefined) {
          newValue.min = firstAttributeKey
        }
        if (!newValue.max && lastAttributeKey !== undefined) {
          newValue.max = lastAttributeKey
        }

        if (newValue.min < firstAttributeKey) {
          newValue.min = firstAttributeKey
          newValueCorrected = true
        }

        if (newValue.max > lastAttributeKey || newValue.max === 0) {
          newValueCorrected = true
          newValue.max = lastAttributeKey
        }

        if (newValue.max < newValue.min) {
          newValue.max = newValue.min
        }

        if (!attributeChanged) {
          if (newValue.max < lastAttributeKey) {
            newValueCorrected = true
            newValue.max = lastAttributeKey
          }
          if (newValue.min > firstAttributeKey) {
            newValueCorrected = true
            newValue.min = firstAttributeKey
          }
        }

        // We set the default minimum and maximum values for sliders only if they haven't been changed by the user
        // (oldValue.min === 0 && oldValue.max === 0) - Both oldValue.min and oldValue.max must be 0 simultaneously
        if (newValueCorrected || (oldValue.min === 0 && oldValue.max === 0) || [oldValue.min, oldValue.max].find(i => i === null || i === undefined) !== undefined) {
          // Force to skip current MinMax Range check
          this.setAttributeValue(dataKey, newValue, true)
        }
      }
    }

    Vue.set(this.filters, key, value)
  }

  getFilterRange (key) {
    const attributeType = this.getAttributeType(key)
    if (!attributeType) {
      console.error(`AttributeType not found by key ${key}`)
      return { min: 0, max: 0 }
    }

    const filter = this.getFilterValue(attributeType.key)

    if (Array.isArray(filter)) {
      const firstAttributeKey = filter[0]?.key
      const lastAttributeKey = filter[filter.length - 1]?.key
      if (firstAttributeKey === lastAttributeKey && firstAttributeKey !== 0) {
        return { min: 0, max: lastAttributeKey || 0 }
      }
      return { min: firstAttributeKey || 0, max: lastAttributeKey || 0 }
    }

    return { min: 0, max: 0 }
  }

  hasFilterRange (key) {
    const attributeType = this.getAttributeType(key)
    if (!attributeType) {
      console.error(`AttributeType not found by key ${key}`)
      return false
    }

    const filter = this.getFilterValue(attributeType.key)

    if (Array.isArray(filter) && filter.length) {
      return true
    }
    return false
  }

  getFilterValue (key) {
    const attributeType = this.getAttributeType(key)
    if (!attributeType) {
      console.error(`AttributeType not found by key ${key}`)
      return
    }
    const dataKey = attributeType.responseKey || attributeType.key
    const value = this.filters[dataKey] || null
    let result = null
    switch (attributeType.type) {
      case SEARCH_STRING_ATTRIBUTE:
        result = `${value}`
        break
      case SEARCH_INTEGER_ATTRIBUTE:
        result = parseInt(value, 10)
        break
      case SEARCH_BOOLEAN_ATTRIBUTE:
        result = !!value
        break
      default:
        result = value
        break
    }
    return result
  }

  setBookingOptionsFilter (key, value) {
    value = value.map((i) => {
      if (i.key === 1) {
        i.name = this.ctx.i18n.t('instant-sail')
      }
      return i
    })
    this.defaultFilterSetter(key, value)
  }
}
